import { classInstance } from '@/shared/helpers/helpers';

export class AccountPersonal {
	private readonly element: HTMLFormElement;

	constructor(element: HTMLFormElement) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	private handleFormSubmit = ({ detail }): void => {
		if (detail.data?.tel) window.app.modal.open('#account-send-code');
	};

	public init = () => {
		classInstance.set(this.element, { accountPersonal: this });
		this.element.addEventListener('formSubmit', this.handleFormSubmit);
	};
}
